import React from 'react';
import { Download, FileText } from 'lucide-react';

const formatSize = (bytes = 0) => (bytes > 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

// Renders one chat attachment: photo, video, audio or a downloadable file.
// `base` is the server origin the relative /uploads/... url is served from.
const ChatAttachment = ({ attachment, base = '' }) => {
    if (!attachment?.url) return null;
    const src = attachment.url.startsWith('/') ? `${base}${attachment.url}` : attachment.url;

    if (attachment.kind === 'image') {
        return (
            <a className="chat-attachment chat-attachment--image" href={src} target="_blank" rel="noreferrer">
                <img src={src} alt={attachment.name || 'Photo'} loading="lazy" />
            </a>
        );
    }
    if (attachment.kind === 'video') {
        return (
            <div className="chat-attachment chat-attachment--video">
                <video src={src} controls preload="metadata" playsInline />
            </div>
        );
    }
    if (attachment.kind === 'audio') {
        return (
            <div className="chat-attachment chat-attachment--audio">
                <audio src={src} controls preload="metadata" />
            </div>
        );
    }
    return (
        <a className="chat-attachment chat-attachment--file" href={src} target="_blank" rel="noreferrer" download={attachment.name}>
            <span className="chat-attachment__icon"><FileText size={20} /></span>
            <span className="chat-attachment__meta">
                <b>{attachment.name || 'File'}</b>
                <small>{formatSize(attachment.size)}</small>
            </span>
            <Download size={16} />
        </a>
    );
};

export default ChatAttachment;
